import React from 'react';
import { LinkItem } from '@atlaskit/menu';
import { log } from '@atlassian/jira-common-util-logging';
import { useIntl } from '@atlassian/jira-intl';
import { useRouter } from '@atlassian/jira-router';
import messages from './messages';

export const readSelectedConfigTab = (): string => {
	const defaultValue = 'filter';
	try {
		const value = localStorage.getItem('selectedConfigTab');
		return value ? JSON.parse(value) : defaultValue;
	} catch (err) {
		log.safeErrorWithoutCustomerData(
			'software-backlog.header.menu.configure-board-item.dropdown-item',
			`Error reading "selectedConfigTab" value: ${err}`,
		);
		return defaultValue;
	}
};

export const ConfigureBoardItem = () => {
	const { formatMessage } = useIntl();
	const selectedConfigTab = readSelectedConfigTab();
	const [{ location }] = useRouter();

	const url = `${location.pathname}?config=${selectedConfigTab}`;

	return (
		<LinkItem
			data-testid="software-backlog.header.menu.configure-board-item.dropdown-item"
			href={url}
		>
			{formatMessage(messages.displayText)}
		</LinkItem>
	);
};

export default ConfigureBoardItem;
